module.exports = __webpack_public_path__ + "media/images/badge-8px-51abe522dba0541bd425691675ad859a.svg";